/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {FolderShareProps} from '../FolderShared';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Folder Shared Opened Icon component.
 */
const FolderSharedOpened = ({folderColor}: FolderShareProps) => {
  const {iconColor} = useIconDLS({color: folderColor});

  return (
    <svg key={folderColor} width='20' height='17' viewBox='0 0 20 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4.757 8.399L2 15.75H16.026C16.4913 15.7499 16.9419 15.5875 17.3004 15.2909C17.6589 14.9943 17.9028 14.582 17.99 14.125L18.986 8.914C19.0098 8.77081 19.0022 8.62415 18.9636 8.48421C18.925 8.34427 18.8564 8.21441 18.7626 8.10365C18.6688 7.99288 18.5519 7.90388 18.4203 7.84281C18.2886 7.78174 18.1452 7.75007 18 7.75H11.8465H5.693C5.48948 7.75008 5.29082 7.81225 5.12357 7.92822C4.95632 8.04419 4.82844 8.20843 4.757 8.399Z' fill={iconColor} />
      <path d='M2 15.75L4.757 8.399C4.82844 8.20843 4.95632 8.04419 5.12357 7.92822C5.29082 7.81225 5.48948 7.75008 5.693 7.75H11.8465H18M2 15.75H16.026C16.4913 15.7499 16.942 15.5875 17.3004 15.2909C17.6589 14.9943 17.9028 14.582 17.99 14.125L18.986 8.914C19.0098 8.77081 19.0022 8.62415 18.9636 8.48421C18.925 8.34427 18.8564 8.21441 18.7626 8.10365C18.6688 7.99288 18.5519 7.90388 18.4203 7.84281C18.2886 7.78174 18.1452 7.75007 18 7.75M2 15.75C1.46957 15.75 0.960859 15.5393 0.585786 15.1642C0.210714 14.7891 0 14.2804 0 13.75V2.75C0 2.21957 0.210714 1.71086 0.585786 1.33579C0.960859 0.960714 1.46957 0.75 2 0.75H6L9 3.75H16C16.5304 3.75 17.0391 3.96071 17.4142 4.33579C17.7893 4.71086 18 5.21957 18 5.75V7.75' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default React.memo(FolderSharedOpened);
